import { Item, ItemContent } from "@volca/ui/components/ui/item";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { dayjs } from "@/core/utils/date";
import type { IAiScriptExplanationChatThread } from "@/payroll/ai-script/types";

interface ChatThreadListItemProps {
  thread: IAiScriptExplanationChatThread;
  isRunning: boolean;
  onOpen: (threadId: string) => void;
}

export const ChatThreadListItem = ({
  thread,
  isRunning,
  onOpen,
}: ChatThreadListItemProps) => (
  <>
    <Item
      size="xs"
      render={<button type="button" />}
      onClick={() => onOpen(thread.id)}
      className="flex-nowrap items-start text-left"
    >
      {isRunning && (
        <Spinner aria-hidden size={16} className="mt-0.5 text-subtle" />
      )}
      <ItemContent className="min-w-0">
        <span className="truncate text-sm text-ink" title={thread.name}>
          {thread.name}
        </span>
        <span className="text-xs text-subtle">
          {isRunning
            ? "Running"
            : thread.last_message_at
              ? dayjs(thread.last_message_at).fromNow()
              : "No messages yet"}
        </span>
      </ItemContent>
    </Item>
    <span role="status" className="sr-only">
      {isRunning ? `${thread.name} is running` : ""}
    </span>
  </>
);
